"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Container = _interopRequireDefault(require("@commerce-ui/core2/Container"));
var _Grid = _interopRequireDefault(require("@commerce-ui/core2/Grid"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _TokenProvider = require("@deosite/api/hooks/common/TokenProvider");
var _CheckoutSteps = _interopRequireDefault(require("@deosite/components-new/CheckoutSteps"));
var _Display = _interopRequireDefault(require("@commerce-ui/core2/Display"));
var _useScrollSegment = _interopRequireDefault(require("@commerce-ui/core2/useScrollSegment"));
var _useScrollDirection = _interopRequireDefault(require("@commerce-ui/core2/useScrollDirection"));
var _useMinicart2 = require("@deosite/api/hooks/common/useMinicart");
var _useLoader2 = require("@deosite/api/hooks/common/useLoader");
var __jsx = _react["default"].createElement;
var MobileMenuIcon = function MobileMenuIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.747 21.056h10.831v1.2H2.748v-1.2zM2.747 15.056h19.28v1.2H2.747v-1.2zM2.747 9.527h19.28v1.2H2.747v-1.2zM2.747 3.527h19.28v1.2H2.747v-1.2z"
  }));
};
MobileMenuIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var CartIcon = function CartIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.723 8.944C2.723 7.54 3.914 6.4 5.384 6.4h14.33c1.47 0 2.662 1.14 2.662 2.544l1.023 13.7c0 1.406-1.191 2.545-2.661 2.545H4.36c-1.47 0-2.662-1.139-2.662-2.544l1.024-13.7zm2.661-1.37c-.791 0-1.433.614-1.433 1.37l-1.023 13.7c0 .758.641 1.37 1.433 1.37h16.377c.791 0 1.433-.613 1.433-1.37l-1.024-13.7c0-.756-.641-1.37-1.433-1.37H5.384z",
    fill: "#2E4557"
  }), __jsx("g", {
    clipPath: "url(#a)",
    stroke: "#2E4557",
    strokeWidth: "1.1",
    strokeMiterlimit: "10"
  }, __jsx("path", {
    d: "M17.8 9.55V5.57M7.55 5.45v4.17M17.8 5.68c0-2.83-2.29-5.12-5.12-5.12a5.12 5.12 0 0 0-5.13 5.12"
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "a"
  }, __jsx("path", {
    fill: "#fff",
    transform: "translate(7)",
    d: "M0 0h11.35v9.62H0z"
  }))));
};
CartIcon.defaultProps = {
  width: "24",
  height: "26",
  viewBox: "0 0 24 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var SearchIcon = function SearchIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.438a7.9 7.9 0 1 0 0 15.8 7.9 7.9 0 0 0 0-15.8zm-9.1 7.9a9.1 9.1 0 1 1 18.2 0 9.1 9.1 0 0 1-18.2 0z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.71 16.7l5.503 5.502-.848.849-5.503-5.503.849-.848z"
  }));
};
SearchIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  minifiedContent: false
};
var Header = function Header(props) {
  var onMobileMenuClick = props.onMobileMenuClick,
    onSearchClick = props.onSearchClick,
    onCartClick = props.onCartClick,
    logo = props.logo,
    button = props.button,
    desktopSearch = props.desktopSearch,
    scrollingPart = props.scrollingPart,
    _props$minifiedConten = props.minifiedContent,
    minifiedContent = _props$minifiedConten === void 0 ? defaultProps.minifiedContent : _props$minifiedConten,
    checkoutUrl = props.checkoutUrl,
    helpLink = props.helpLink,
    additionalLogo = props.additionalLogo,
    cssOverride = props.cssOverride,
    bgColor = props.bgColor,
    logoFillColor = props.logoFillColor;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useLoader = (0, _useLoader2.useLoader)(),
    submenuLoaded = _useLoader.submenuLoaded;
  var translations = {
    login: (0, _langLibrary["default"])("Log in"),
    register: (0, _langLibrary["default"])("Register"),
    myAccount: (0, _langLibrary["default"])("My account"),
    needHelp: (0, _langLibrary["default"])("Needs help?"),
    shipment: (0, _langLibrary["default"])("Shipment"),
    payment: (0, _langLibrary["default"])("Payment"),
    cart: (0, _langLibrary["default"])("Cart")
  };
  var _useMinicart = (0, _useMinicart2.useMinicart)(),
    itemsAmount = _useMinicart.itemsAmount;
  var steps = [{
    text: translations.shipment,
    route: "checkout"
  }, {
    text: translations.payment,
    route: "checkout-payment"
  }];
  var isNotAtTop = (0, _useScrollSegment["default"])({
    from: 1
  });
  var isScrollingDown = (0, _useScrollDirection["default"])();
  if (isScrollingDown === undefined && scrollingPart) {
    return __jsx(_react["default"].Fragment, null);
  } else {
    return __jsx("header", null, __jsx(_Box["default"], {
      sx: {
        borderBottomWidth: ["1px", null, null, null, "0", null],
        borderStyle: "solid",
        borderColor: "neutral",
        bg: bgColor !== null && bgColor !== void 0 ? bgColor : "transparent",
        display: scrollingPart && (!isNotAtTop || !isScrollingDown) ? "none" : "block"
      }
    }, __jsx(_Container["default"], {
      margin: isNotAtTop && isScrollingDown ? ["containerMargin", null, null, null, 26] : "containerMargin"
    }, __jsx(_Grid["default"], {
      cols: isNotAtTop && isScrollingDown ? [24, null, null, null, 20] : 1
    }, __jsx(_Box["default"], {
      sx: {
        gridColumn: checkoutUrl && (!isNotAtTop || !isScrollingDown) ? "span 24" : isNotAtTop && isScrollingDown ? ["span 24", null, null, null, "span 20"] : "unset",
        height: isNotAtTop && isScrollingDown ? cssOverride ? [cssOverride.scrollingHeaderHeightMobile + "px", null, null, null, cssOverride.scrollingHeaderHeight + "px"] : ["48px", null, null, null, "68px"] : cssOverride ? [cssOverride.headerHeightMobile + "px", null, null, null, cssOverride.headerHeight + "px", null] : ["48px", null, null, null, "72px", null],
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "relative",
        color: "main",
        background: bgColor !== null && bgColor !== void 0 ? bgColor : "white"
      }
    }, !minifiedContent && __jsx(_Box["default"], {
      sx: {
        display: ["flex", null, null, null, "none", null],
        flex: [null, null, null, null, "1", null],
        zIndex: "1"
      },
      as: "div"
    }, /*#__PURE__*/_react["default"].cloneElement(button, {
      disabled: !submenuLoaded,
      onClick: onMobileMenuClick
    }, __jsx(MobileMenuIcon, null)), __jsx(_Box["default"], {
      sx: {
        pl: "s6"
      }
    }, /*#__PURE__*/_react["default"].cloneElement(button, {
      onClick: onSearchClick,
      "data-test": "open-search-mobile"
    }, __jsx(SearchIcon, null)))), !minifiedContent && __jsx(_Box["default"], {
      sx: {
        zIndex: 2
      }
    }, __jsx(_Box["default"], {
      sx: {
        display: isNotAtTop && isScrollingDown ? "none" : ["none", null, null, null, "block", null]
      }
    }, desktopSearch)), __jsx(_Box["default"], {
      sx: {
        width: isNotAtTop && isScrollingDown ? ["100%", null, null, null, "auto", null] : "100%",
        position: "absolute",
        textAlign: "center",
        zIndex: [0, null, null, null, 1, null],
        transition: "200ms",
        ":hover": {
          opacity: "0.9"
        },
        flex: ["1", null, null, null, "1", null],
        alignItems: "center",
        svg: {
          fill: logoFillColor !== null && logoFillColor !== void 0 ? logoFillColor : "main",
          width: isNotAtTop && isScrollingDown ? cssOverride ? ["auto", null, null, null, cssOverride.logoWidthScrolling + "px", null] : ["auto", null, null, null, "120px", null] : cssOverride ? ["auto", null, null, null, cssOverride.logoWidth + "px", null] : ["auto", null, null, null, "150px", null],
          height: ["24px", null, null, null, "44px", null],
          maxWidth: isNotAtTop && isScrollingDown ? ["unset", null, null, null, "8vw", null] : "unset"
        }
      }
    }, __jsx(_Box["default"], {
      sx: {
        height: "44px",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        alignContent: "center"
      }
    }, __jsx(Link, {
      route: "home-page"
    }, __jsx(_LinkRaw["default"], {
      title: "Dajar",
      sx: {
        display: "flex",
        justifyContent: "center"
      }
    }, isNotAtTop && isScrollingDown ? additionalLogo !== null && additionalLogo !== void 0 ? additionalLogo : logo : logo)))), !minifiedContent && __jsx(_Box["default"], {
      sx: {
        font: "body2",
        zIndex: "1",
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "center"
      }
    }, (!isNotAtTop || !isScrollingDown) && __jsx(_Box["default"], {
      sx: {
        mr: "s8",
        display: "inline-block"
      }
    }, token ? __jsx(_Box["default"], null, __jsx(_Box["default"], {
      sx: {
        display: ["none", null, null, null, "inline-block", null]
      }
    }, __jsx(Link, {
      route: "account-info"
    }, __jsx(_LinkRaw["default"], {
      title: translations.myAccount,
      "data-test": "my-account-link"
    }, translations.myAccount)))) : __jsx(_Box["default"], {
      sx: {
        display: ["none", null, null, null, "inline-block", null]
      }
    }, __jsx(Link, {
      route: "login"
    }, __jsx(_LinkRaw["default"], {
      title: translations.login,
      "data-test": "login-link"
    }, translations.login)))), !token && (!isNotAtTop || !isScrollingDown) && __jsx(_Box["default"], {
      sx: {
        mr: "s8",
        display: ["none", null, null, null, "inline-block", null]
      }
    }, __jsx(Link, {
      route: "register"
    }, __jsx(_LinkRaw["default"], {
      title: translations.register,
      "data-test": "registration-link"
    }, translations.register))), __jsx(_Box["default"], {
      "data-test": "mini-cart"
    }, /*#__PURE__*/_react["default"].cloneElement(button, {
      onClick: function onClick() {
        return onCartClick();
      }
    }, __jsx(_Box["default"], {
      sx: {
        font: "body2",
        color: "main",
        mr: "s4",
        display: ["none", null, "block"]
      }
    }, translations.cart), __jsx(_Box["default"], {
      sx: {
        width: "28px",
        height: "28px",
        position: "relative",
        display: "inline-block",
        textAlign: "center"
      }
    }, __jsx(CartIcon, null), __jsx(_Box["default"], {
      as: "span",
      sx: {
        position: "absolute",
        font: "xxs_caps",
        bottom: 2,
        right: [3, null, null, null, null, 4],
        width: "20px",
        height: "20px",
        lineHeight: "20px"
      }
    }, itemsAmount))))), minifiedContent && __jsx(_Display["default"], {
      when: [false, null, null, checkoutUrl !== "/checkout/success"]
    }, __jsx(_Box["default"], {
      sx: {
        position: "relative",
        zIndex: "1",
        py: "0px",
        left: isScrollingDown ? ["unset", null, null, "10vw", null, "8vw"] : "unset"
      }
    }, __jsx(_CheckoutSteps["default"], {
      steps: steps,
      activeStep: checkoutUrl === "/checkout" ? 0 : 1,
      sx: {
        position: "relative",
        zIndex: "1",
        py: "0px"
      }
    }))), minifiedContent && __jsx(_Box["default"], {
      sx: {
        position: "relative",
        zIndex: "1",
        marginLeft: "auto",
        marginRight: "0px"
      }
    }, __jsx(Link, {
      route: helpLink
    }, __jsx(_LinkRaw["default"], {
      title: translations.needHelp,
      sx: {
        font: "xs_underline",
        cursor: "pointer"
      }
    }, translations.needHelp))))))));
  }
};
var _default = Header;
exports["default"] = _default;